import TodayMarker from '../../chart/todayMarker';
import Config from '../../config';
import Columns from '../../grid/columns';
import Zoom from '../../chart/zoom';
import Baselines from '../../baselines';
import Filter from '../../controllers/filter';

export default instance => {
  instance.attachEvent('export:onConfigOptionChange', option => {
    if (option.id === 'current_day_marker') {
      option.value ? TodayMarker.addMarker() : TodayMarker.removeMarker();

      return;
    }

    Config.setConfigParameter(option.id, option.value, true);
  });

  instance.attachEvent('export:onColumnVisibilityChange', column => {
    Columns.changeColumnCheckbox(column.isAdvanced ? column.mainColumnId : column.id, column.isVisible, column.isAdvanced);
    instance.render();
  });

  instance.attachEvent('export:onZoomChange', zoomLevel => {
    Zoom.setZoomLevel(zoomLevel);
  });

  instance.attachEvent('export:onBaselineEnable', async baseline => {
    await Baselines.buildBaseline(baseline);
  });

  instance.attachEvent('export:onBaselineDisable', baselineId => {
    Baselines.removeBaseline(baselineId);
  });

  instance.attachEvent('export:onChangeFilterState', () => {
    Filter.run();
  });

  instance.attachEvent('export:onCustomColumnsValuesLoaded', () => {
    instance.render();
  });
};
